import { TRANSFER_STATE_STATUS } from '~/constants/transfer'
import { ActionTypes, DEPOSIT_ACTIONS, State } from './types'

export const initialState: State = {
  bankNetwork: null,
  blockchainNetwork: null,
  currency: null,
  status: TRANSFER_STATE_STATUS.IDLE,
  transferMethod: null,
}

export const deposit = (state = initialState, action: ActionTypes): State => {
  switch (action.type) {
    case DEPOSIT_ACTIONS.SET_BANK_NETWORK: {
      return {
        ...state,
        bankNetwork: action.payload,
      }
    }
    case DEPOSIT_ACTIONS.SET_BLOCKCHAIN_NETWORK: {
      return {
        ...state,
        blockchainNetwork: action.payload,
      }
    }
    case DEPOSIT_ACTIONS.SET_CURRENCY: {
      return {
        ...state,
        currency: action.payload,
      }
    }
    case DEPOSIT_ACTIONS.SET_STATUS: {
      return {
        ...state,
        status: action.payload,
      }
    }
    case DEPOSIT_ACTIONS.SET_TRANSFER_METHOD: {
      return {
        ...state,
        transferMethod: action.payload,
      }
    }
    case DEPOSIT_ACTIONS.RESET_DEPOSIT: {
      return initialState
    }
    default:
      return state
  }
}
